/** @typedef {import("../../../api/types").Order} Order */

/**
 * The address the customer opens to see (and answer) an order, or null when
 * the order has no link (the API only gives a token while it is Open or Sent).
 *
 * @param {Pick<Order, "link_token">} order
 * @returns {string|null}
 */
export const orderPublicLink = (order) =>
    order.link_token ? `${window.location.origin}/quotes/${order.link_token}` : null;
